import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';

import { localImages, stringsList } from '../../dashboard/constants/app-config'
import { ClientUpdateDialogComponent } from '../atoms/client-update-dialog/client-update-dialog.component';
import { ClientService } from '../preview/invoices/services/client.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.css',
    '../styles/styles.css'
  ]
})
export class HeaderComponent implements OnInit {
  stringList = stringsList
  localImages = localImages
  user: any

  constructor(private router: Router, private dialog: MatDialog, private clientService: ClientService) { }

  async ngOnInit(): Promise<void> {
    this.user = await Auth.currentAuthenticatedUser()
  }

  openClientDialog() {
    this.clientService.GetClient(this.user.attributes.sub).then((data: any) => {
      const dialogRef = this.dialog.open(ClientUpdateDialogComponent, this.openDialogProperties(data))
      dialogRef.afterClosed().subscribe((response: any) => {
        if (response.action === 'Save changes') {
          let updatingClient = {
            id: response.data.id,
            username: response.data.username,
            email: response.data.email,
            company: response.data.company,
            phone: response.data.phone,
            address: response.data.address,
            city: response.data.city
          }
          this.clientService.UpdateClient(updatingClient).catch(err => {
            console.log(err)
          })
          if (response.data?.oldPassword && response.data?.newPassword) {
            Auth.changePassword(this.user, response.data.oldPassword, response.data.newPassword).catch(err => { console.log(err) })
          }
        }
      })
    }).catch((err) => console.log(err));
  }

  logOut() {
    localStorage.clear();
    this.router.navigate(['login']);
  }

  openDialogProperties(client: any) {
    return {
      width: '600px',
      height: '670px',
      data: client
    }
  }

  redirectToMainPage() {
    this.router.navigate(['overview'])
  }

}
